// removed by extract-text-webpack-plugin
module.exports = {"authForm":"_1J4Oj","header":"m4O2z","subheader":"Ov_k2","body":"_2LWHC","relativeWrapper":"_2Cq7T","passwordVisibleButton":"_3eg88","input":"_3BtwC","continueButton":"cENQv","smallText":"_1b_lt","error":"_3HFgg","poweredBy":"_21TJ9"};


//////////////////
// WEBPACK FOOTER
// ./banquet/components/AuthForm/index.sass
// module id = 1459
// module chunks = 1